import React from 'react';
import { BrowLine } from './BrowLine';
import { Accent } from './SectionHeading';
import { teachingSkills } from '../../data/content';
const dots = ['#F6D3D6', '#CFE0F0', '#F3E3D2', '#F6E3B6', '#D6E4CB', '#DDD4F0'];

/** Section 8 — dark, distinctive positioning block. */
export function NotEbookSection() {
  return <section aria-labelledby="ebook-heading" className="relative overflow-hidden bg-brand-charcoal px-5 py-16 text-brand-ivory lg:px-8 lg:py-24" data-id="element-124" data-mp="2yqyn8ydoyd3m">
      <BrowLine className="pointer-events-none absolute -right-10 top-10 hidden h-24 w-[26rem] text-brand-gold/20 lg:block" data-id="element-125" data-mp="2otki3ux7xaqm" />
      <div className="relative mx-auto max-w-6xl" data-id="element-126" data-mp="2auugq33d8owg">
        <div className="mx-auto max-w-2xl text-center" data-id="element-127" data-mp="2awe0i3o8di2z">
          <h2 id="ebook-heading" className="font-display text-[2.1rem] font-bold leading-[1.08] text-brand-ivory sm:text-[2.75rem]" data-id="element-128" data-mp="2ftxed2h0nsue">
            This Isn’t Just <Accent data-id="element-129" data-mp="e2155zibmv2s">Another Brow Ebook.</Accent>
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-brand-ivory/70 sm:text-[16px]" data-id="element-130" data-mp="dzeuvs41q1gv">
            Brow Instructor Ready™ wasn’t created for clients who want to learn how to do their own
            brows.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-brand-ivory/90 sm:text-[16px]" data-id="element-131" data-mp="1393yc3g2gkeu">
            It was designed for professionals who need to{' '}
            <strong className="font-bold text-brand-butter" data-id="element-132" data-mp="z93jwisyw97s">TEACH</strong> brow skills to other
            professionals.
          </p>
        </div>

        <ol className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-[22px] bg-brand-ivory/10 sm:grid-cols-3 lg:grid-cols-6" data-id="element-133" data-mp="6j3gkoe47471">
          {teachingSkills.map((skill, index) => <li key={skill.word} className="flex flex-col bg-brand-charcoal px-5 py-7" data-id="element-134" data-mp="fii1z9ffcoko" data-mpi={index}>
              <span className="flex items-center gap-2 font-body text-[11px] font-semibold tracking-[0.16em] text-brand-ivory/45" data-id="element-135" data-mp="1vwzv185mycbm">
                <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{
              backgroundColor: dots[index]
            }} data-id="element-136" data-mp="1qx55b7xljss5" />
                {index + 1}
              </span>
              <span className="mt-4 font-display text-[1.5rem] font-bold uppercase leading-none tracking-[0.04em] text-brand-ivory" data-id="element-137" data-mp="tjlggfe4jvwj">
                {skill.word}
              </span>
              <span className="mt-3 text-[13px] leading-relaxed text-brand-ivory/55" data-id="element-138" data-mp="xjm8j2u5c5m2">{skill.line}</span>
            </li>)}
        </ol>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-ivory sm:text-[1.9rem]" data-id="element-139" data-mp="5vandyeo70it">
          Because Doing Brows Is One Skill. <Accent data-id="element-140" data-mp="eufl52ieqptx">Teaching Them Is Another.</Accent>
        </p>
      </div>
    </section>;
}